document.addEventListener("turbolinks:load", function() {
	$(document).on("click","[data-alternate-photo-upload]", function() {
		$("#tag_photo").removeAttr("disabled");
	});
})
